import {memo} from 'react';
import styled from 'styled-components';
import {PaddingBottom} from '../padding/PaddingBottom';
import {TextBodyMedium} from '../text/TextBodyMedium';
import {TextHeading1} from '../text/TextHeading1';
import {
  animatedGradients,
  getAnimatedGradientStyles,
} from '../../utils/gradients';
import {getRandomItem} from 'hubbl-shared';

interface WelcomeSectionProps {
  title: string;
  description: string;
}

export const WelcomeSection = memo(
  ({title, description}: WelcomeSectionProps) => {
    return (
      <WelcomeSectionInternal>
        <WelcomeContent>
          <TextHeading1 text={title} />
          <PaddingBottom amount={16} />
          <TextBodyMedium text={description} />
        </WelcomeContent>
      </WelcomeSectionInternal>
    );
  },
);

const WelcomeSectionInternal = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem;
  border-radius: 16px;
  margin-bottom: 2rem;
  ${getAnimatedGradientStyles(
    getRandomItem(
      Object.keys(animatedGradients) as (keyof typeof animatedGradients)[],
    ) || 'oceanBreeze',
  )};
`;

const WelcomeContent = styled.div`
  flex: 1;
`;
